import {useDispatch, useSelector} from 'react-redux';
import {handleTracking} from '@jobseeker/common-core/utils';
import HeaderWithProfile from '../Header/Containers/WithProfile';
import {logout} from '../../helpers';

import type {HeaderPropType} from './types';
import type {AppState} from '@jobseeker/common-core/types';
import {useEffect} from 'react';
import {userProfile} from '@jobseeker/common-core/helpers/user';

const HeaderProfile = (props: HeaderPropType) => {
  const {
    config: {
      showSearchBar = true,
      showDownloadApp = true,
      showJobSeeker = true,
      showRecruiter = true,
      showLogo = true,
    },
    ...prop
  } = props || {};

  const {isLoggedIn, userId} = useSelector((state: AppState) => state.auth);
  const {
    profile: {email},
  } = useSelector((state: AppState) => state.user);

  const {
    timelines: {
      config: {competitionName, competitionId},
    },
  } = useSelector((state: AppState) => state.competition);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  const handleLogout = async () => {
    handleTracking('jsClickLogin_LoggedOut', {
      event_category: 'Reset Password',
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
    });
    // remove the userId from the session storage
    sessionStorage.removeItem('userId');
    await logout(true, `/${competitionName}`);
  };

  const handleLogin = () => {
    dispatch({
      type: 'AppContext/set_login_popup',
      payload: true,
    });
  };

  useEffect(() => {
    const getProfile = async (): Promise<void> => {
      const profileCall =
        props?.page.indexOf('epoch') > -1
          ? `profile?epoch=true&competitionId=${competitionId}`
          : 'profile';

      await userProfile(profileCall, dispatch);
    };

    if (userId !== '-1' && isLoggedIn && !email) {
      getProfile();
    }
  }, [userId, isLoggedIn, email]);

  return (
    <HeaderWithProfile
      reCap={0}
      proMeta={{
        refCode: '',
        refFeature: '',
      }}
      config={{
        showSearchBar: showSearchBar,
        showDownloadApp: showDownloadApp,
        showJobSeeker: showJobSeeker,
        showRecruiter: showRecruiter,
        showLogo: showLogo,
      }}
      OnLogoutBtnClick={handleLogout}
      onLoginClick={handleLogin}
      {...prop}
    />
  );
};

export default HeaderProfile;
